import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { LoadOptions } from 'devextreme/data/load_options';


export class FileLookupService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/filelookup');
    
  }

  async searchFiles(options: LoadOptions) : Promise<any> {
    return await this.client.getPostData(`/search`, options);
  }
  
}
